import { push } from 'connected-react-router';
import { DASHBOARD_PAGE_ROUTE } from 'utils/constants/app';

import dashboardMainTabsButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_main_tabs_button_click';

import Tabs, { Tab } from 'bloko/blocks/tabs';

import useTrls from 'hooks/translation/useTrls';

import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';

import { CampaignTabStatus } from 'store/models/dashboard';
import { useDispatch, useSelector } from 'store/utils';

const DEFAULT_TABS = [CampaignTabStatus.Active, CampaignTabStatus.Off];

const TabsStatus = () => {
    const counts = useSelector((state) => state.countsCampaign);
    const currentStatus = useSelector((state) => state.campaignTabsStatus);

    const dispatch = useDispatch();

    const trl = useTrls();

    const trlTabs = {
        [CampaignTabStatus.Active]: trl('dashboard.title.tabs.statusPublic'),
        [CampaignTabStatus.Off]: trl('dashboard.title.tabs.statusOff'),
    };

    return (
        <>
            <Tabs
                onChange={(id) => {
                    if (id !== currentStatus) {
                        if (id === CampaignTabStatus.Off) {
                            dashboardMainTabsButtonClick({
                                buttonName: 'dashboard_archived_tab',
                                campaignCount: counts[id],
                            });
                            dispatch(push(`${DASHBOARD_PAGE_ROUTE}archive`));
                        }
                        if (id === CampaignTabStatus.Active) {
                            dashboardMainTabsButtonClick({
                                buttonName: 'dashboard_active_tab',
                                campaignCount: counts[id],
                            });
                            dispatch(push(DASHBOARD_PAGE_ROUTE));
                        }
                    }
                }}
            >
                {DEFAULT_TABS.map((tab) => (
                    <Tab
                        key={tab}
                        active={currentStatus === tab}
                        id={tab}
                        data-qa={tab === CampaignTabStatus.Off ? 'campaigns-off' : 'campaigns-on'}
                    >
                        {trlTabs[tab]}
                        {tab in counts ? ` (${counts[tab]})` : ''}
                    </Tab>
                ))}
            </Tabs>
        </>
    );
};

export default withErrorBoundary(TabsStatus);
